import {FC} from 'react'
import {useListView} from '../../core/ListViewProvider'
import {RolesListToolbar} from './RolesListToolbar'
import {RolesListGrouping} from './RolesListGrouping'
import {RolesListSearchComponent} from './RolesListSearchComponent'
import { checkPermission } from 'app/utils/checkPermission'

const RolesListHeader: FC = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      {checkPermission('Roles','list')? <RolesListSearchComponent /> : 
        <div className='d-flex align-items-center position-relative my-1'></div>
      }
      <div className='card-toolbar'>
        {selected.length > 0 && checkPermission('Roles','manage')? <RolesListGrouping /> : <RolesListToolbar />}
      </div>
    </div>
  )
}

export {RolesListHeader} 